import { RequestWithdrawStatus } from 'configs/constants';
import { subMonths, endOfDay, startOfDay } from 'date-fns';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'configs';
import { formatDateTime } from 'utils/helpers/helpers';

export type FilterType = {
  phoneNumber?: string;
  transactionStatus:
    | 'Tất cả'
    | 'Thành công'
    | 'Từ chối'
    | 'Đang xử lý'
    | 'Đang chuyển tiền tự động'
    | 'Chuyển tiền tự động thất bại';
  fromTime: string | number;
  toTime: string | number;
  compId?: string;
  refreshData: number;
  pageSize: number;
  pageIndex: number;
};

export const getInitFilterValues = (urlParams: any): FilterType => {
  return {
    phoneNumber: urlParams?.get('phoneNumber') ?? '',
    transactionStatus:
      urlParams?.get('transactionStatus') ?? RequestWithdrawStatus['Tất cả'],
    compId: urlParams?.get('compId') ?? 'Tất cả',
    fromTime:
      urlParams?.get('fromTime') ??
      startOfDay(subMonths(new Date(), 1)).toISOString(),
    toTime: urlParams?.get('toTime') ?? endOfDay(new Date()).toISOString(),
    refreshData: 0,
    pageSize: Number(urlParams?.get('pageSize') ?? DEFAULT_PAGE_SIZE),
    pageIndex: Number(urlParams?.get('pageIndex') ?? DEFAULT_PAGE_INDEX),
  };
};

export const convertVariables = (variables: FilterType) => {
  const { fromTime, toTime, compId, ...rest } = variables;

  const newTimeFrom =
    typeof fromTime === 'string' ? new Date(fromTime).getTime() : fromTime;
  const newTimeTo =
    typeof toTime === 'string' ? new Date(toTime).getTime() : toTime;

  if (compId === 'Tất cả') {
    return {
      ...rest,
      fromTime: fromTime ? formatDateTime(Number(newTimeFrom)) : '',
      toTime: toTime ? formatDateTime(Number(newTimeTo), true) : '',
    };
  }

  return {
    ...rest,
    compId,
    fromTime: fromTime ? formatDateTime(Number(newTimeFrom)) : '',
    toTime: toTime ? formatDateTime(Number(newTimeTo), true) : '',
  };
};

export const convertSelectStatusOptions = () => {
  return Object.keys(RequestWithdrawStatus).map((key: string) => {
    return {
      label: RequestWithdrawStatus[key as keyof typeof RequestWithdrawStatus],
      value: key,
    };
  });
};

export const exportHeaders = [
  'STT',
  'Mã giao dịch',
  'Tài khoản',
  'Tên KH thụ hưởng (Beneficiary)',
  'Nội dung chuyển khoản (Contents)',
  'Số tiền (Amount)',
  "Tài khoản thụ hưởng (Beneficiary's account)",
  "Ngân hàng thụ hưởng (Beneficiary's bank)",
  "Mã Ngân hàng - Bạn Không điền vào cột này (Bankcode - Please don't input)",
  'Trạng thái',
  'Thời gian gửi',
  'Phương pháp duyệt',
  'Thời gian duyệt',
  'Nguyên nhân từ chối',
  'Hình ảnh',
];
